const { escapeHTML } = require("core-js/core/string");

(function ( $ ) {

	$.fn.svChat = function ( options ) {
		var settings = $.extend({
			inst_short_name: '', 
			is_default_css: true,
			queues:{},
			doActionBeforeShowChat: function(){
				return true;
			}
			
		}, options);
		var q, topicContent;
		var caller = {};
		var chatServerUrl = settings.chatServerUrl;
		var _this = this;
		var chat_session_id;
		var socket;
		var isOpen;
		var chatReconnectTimeout;
		$.fn.setQueue = function ( queue ) {
			/*
			 *  set queues
			 */
			
			/*var queues = settings.queues;
			for(var index in queues) {
				if(queues[index] == queue){
					q = queues[index];
					return true;
				}
			}
			return false;*/
			q = queue;
			sessionStorage.setItem('queueId',q);
		}
		
		$.fn.setTopicContent = function(topic_content){
			topicContent = topic_content;
			lowerCaseTopic_content = topic_content.toLowerCase();
			const keywords = ['script', 'alert', 'img', 'image', 'iframe'];
			const containsKeyword = keywords.some(keyword => lowerCaseTopic_content.includes(keyword));
			if (containsKeyword) {
			// Regex to replace the XSS values
			topicContent = topic_content.replace(/</g, '(').replace(/>/g, ')');
			
			topicContent = topicContent.replace(/(alert)\(([^)]+)\)/gi, "$1'$2'");
			}
			sessionStorage.setItem('topicContent',topicContent);
		}
		
		$.fn.getQueue = function ( ) {
			/*
			 *  set queues
			 */
			
			return q;
		}
		
		$.fn.setCaller = function ( callerInfo ) {
			/*
			 *  set caller info
			 */
			caller = callerInfo;
		}
		
		function loadCss(url) {
			var link = document.createElement('link');
			link.type = 'text/css';
			link.rel = 'stylesheet';
			link.href = url;
			document.getElementsByTagName("head")[0].appendChild(link);
		}
		
		function loadJs(){
			$.getScript(chatServerUrl+'/chat/lib/socket.io-client/socket.io.js', function(data, textStatus, jqXHR){
				if(textStatus == 'success'){
					if($('#smartChat').length && $('#smartChat').length>0){
						_this.showChat();	 
						return;       
					   }
					   
					_this.append('<div id="smartChat" class="chatIcon"></div>');
					console.log(document.getElementById('smartChat'))
					var chatWindowHtml = '<div id="smartchatWindow" class="smartchatWindow popup-box ">'+
						'<div class="chatPopHeader">' +
								'<span class="headerContent popup-head-left">'+settings.i18n['chat.svchatplugin.welcome']+'</span>' +
									'<a class="closeChat popup-head-right fa fa-close text-muted" id="closeChat" style="color: #a9a9a9; float:right;right: 10px;font-size: 1.25em;"></a>' +
						'</div>' +
						'<div  id="refreshContent" class="refreshContent" style="display:none"><i id="contentList" class="fc fc-spinner fc-spin fc-4x"></i></div>'+
						'<div class="chatContentBox">'+
						'<div class="chatContent"></div></div>'+
						'<div class="typeTip">'+
						'<span class="typing_loader"></span>'+
						'</div>'+
						'<div class="panel-footer">'+
					    '<div class="input-group mb0">'+
					      '<input class="form-control noshade chatInput" placeholder= "'+settings.i18n["chat.svchatplugin.typehere"]+'" type="text">'+
					      '<div class="input-group-btn">'+
					        '<button id="sendMsg" type="button" class="btn btn-send fa fa-mail-reply f15" title="'+settings.i18n['chat.svchatplugin.sendMessage']+'"></button>'+
					      '</div>'+
					    '</div>'+
					  '</div>'+
						'<div id="status" class="status_bar popup-bottom">'+
						'</div>'+
						'<bgsound id="bg_sound">'+
					  '</div>';
					_this.after(chatWindowHtml);
					changeMobileChatcontentHeigh();
					$(window).resize(function (){
						changeMobileChatcontentHeigh();
					});
					$("#smartChat").click(function(){
						var isShow = settings.doActionBeforeShowChat();
						if(isShow){
							_this.showChat();	
						}
					});
					
				}
			});
		}
		
		function getCssAndJs(){
			var chatCss = chatServerUrl+'/src/assets/css/frontend.css';
			var fontAwesomeCss = '//netdna.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.css';
			loadCss(chatCss);
			loadCss(fontAwesomeCss);
			loadJs();
		}
		
		getCssAndJs();

		window.onresize=function(){
			if(isOpen && ($(window).innerWidth()<=1024 || mobileBrowser() || iPhoneBrowser())){
				 $("body").css("position","fixed");
			 }else{
				 $("body").css("position","");
			 }
		};
		
		function getInstName() {
			/*
			 *  show chat
			 */
			return '';
		}
		function initESAPI(){
			Base.esapi.properties.application.Name = "Chat application";
		    // Initialize the api
		    org.owasp.esapi.ESAPI.initialize();
		}
		$.fn.showChat = function() {
			/*
			 *  show chat 
			 */
			jsonp(chatServerUrl+'/chat/connected', null, function(time){
				chatReconnectTimeout = time;
				if($('#smartchatWindow').css("visibility") == 'visible'){
					return;
				}
				if(checkCookie()){
					return;
				}
				socket = io.connect(chatServerUrl);
				console.log("Amanath connected")
				if($(window).innerWidth()<=1024 || mobileBrowser() || iPhoneBrowser()){
					 $("body").css("position","fixed");
				}
				clearMsg();
				isOpen = true;
				sessionStorage.removeItem('isOpen');
				setCookie('isOpened','true');
				$('#smartchatWindow').css("visibility", "visible");
				var reconnectTime;
				var flag = false;
				var typing = false;
				var lastTypingTime;
				var typingTimeLength = 3 * 1000;
				var obj = {
					caller: caller,
					queue_id: q,
					inst_short_name: settings.inst_short_name,
					topicContent: topicContent
				};
				var chatObj = {
					queue_id: sessionStorage.getItem('queueId'),
					sessionId: sessionStorage.getItem('chatSessionId'),
					system_data: sessionStorage.getItem('system_data'),
					topic_content_data: sessionStorage.getItem('topic_content_data'),
					inst_short_name: settings.inst_short_name
				};
				if(sessionStorage.getItem('isOffHours')){
					/* SPS-10500 In order to make the URL/Links clickable in Chat/Case OFF Message we are removing the pattern(/<[^>]+>/g).
					This pattern coverts the URL/Links to text messages */
					//var offHoursMessage = sessionStorage.getItem('hourChatMessage').replace(/<[^>]+>/g,"");
					var offHoursMessage = sessionStorage.getItem('hourChatMessage');
					var data = {
							message: offHoursMessage,
							time: new Date().getTime(),
							author: 'System'
						};
					addMessageToChatContent(data);
					$('.chatInput').attr('disabled',true);
					$('#sendMsg').attr('disabled',true);
				}else{
					if(sessionStorage.getItem('refreshPage')){
						if(chatObj.system_data){
							if(chatObj.topic_content_data){
								addMessageToChatContent(JSON.parse(chatObj.topic_content_data));
							}
							addMessageToChatContent(JSON.parse(chatObj.system_data));
							$('.chatInput').attr('disabled',true);
							$('#sendMsg').attr('disabled',true);
							if(sessionStorage.getItem('showEndMsg')){
								showEndMsg();
							}
						}else if(chatObj.sessionId){
							chat_session_id = chatObj.sessionId;
							socket.emit('reconnectChat', chatObj);
						}
					}else{
						obj.queryParams = {};
						socket.emit('startChatForUser', obj);
					}
				}
				socket.on('advisor_accept', function(data){
					$('.chatInput').attr('disabled',false);
					data.message = checkUrl(data.message,'advisor_accept');
					chat_session_id = data.chat_session_id;
					sessionStorage.setItem('queueId',data.queueId);
					addMessageToChatContent(data);
			    	sessionStorage.removeItem('isWaiting');
			    	msgSound();
					// $('.headerContent').text('Welcome to ' + data.inst_name);
					// $('.statusBar').text('You are chatting with ' + data.advisor_first_name + data.advisor_last_name);
				});
				socket.on('offline_accept', function(data){
					$('.chatInput').attr('disabled',false);
					data.message = checkUrl(data.message,'offline_accept');
					chat_session_id = data.chat_session_id;
					sessionStorage.setItem('queueId',data.queueId);
					addMessageToChatContent(data);
					msgSound();
				});
				socket.on('system_message', function(data){
					data.message = checkUrl(data.message,'system_message');
					addMessageToChatContent(data);
					$('.chatInput').attr('disabled',true);
					$('#sendMsg').attr('disabled',true);
					sessionStorage.setItem('system_data',JSON.stringify(data));
					msgSound();
				});
				socket.on('chatbot_accept', function(data){
					$('.chatInput').attr('disabled',false);
					data.message = checkUrl(data.message,'chatbot_accept');
					chat_session_id = data.chat_session_id;
					sessionStorage.setItem('queueId',q);
					addMessageToChatContent(data);
					// $('.headerContent').text('Welcome to ' + data.inst_name);
					// $('.statusBar').text('You are chatting with ' + data.advisor_first_name + data.advisor_last_name);
				});
				socket.on('advisor_message', function(data){
					$('.chatInput').attr('disabled',false);
					data.message = checkUrl(data.message,'advisor_message');
					if(data.status == "serverDown"){
						showEndMsg();
					}else{
						addMessageToChatContent(data);
					}
					msgSound();
				});
				socket.on('chatbot_message', function(data){
					$('.chatInput').attr('disabled',false);
					data.message = checkUrl(data.message,'chatbot_message');
			    	addMessageToChatContent(data);
				});
				socket.on('user_message', function(data){
					$('.chatInput').attr('disabled',false);
					data.message = checkUrl(data.message,'user_message');
					addMessageToChatContent(data);
				});
				socket.on('return_no_advisor_message', function(data){
					data.message = checkUrl(data.message,'return_no_advisor_message');
					chat_session_id = data.chat_session_id;
					addMessageToChatContent(data);
			    	$('.chatInput').attr('disabled',true);
					$('#sendMsg').attr('disabled',true);
			    	sessionStorage.setItem('isWaiting',true);
			    	msgSound();
						// $('.headerContent').text('Welcome to ' + data.inst_name);
						// $('.statusBar').text('No advisor chatting with you.');
				});
				socket.on('advisor_close', function(data){
					data.message = checkUrl(data.message),'advisor_close';
					addMessageToChatContent(data);
			    	$('.chatInput').attr('disabled',true);
					$('#sendMsg').attr('disabled',true);
			    	sessionStorage.setItem('isAdvisorClose',true);
			    	socket.close();
			    	msgSound();
				});
				socket.on('topicContent', function(data){
					sessionStorage.setItem('topic_content_data',JSON.stringify(data));
					$('.chatInput').attr('disabled',false);
					data.message = checkUrl(data.message,'topicContent');
					addMessageToChatContent(data);
				});
				socket.on('history', function(histories){
					$(".chatContent").empty();
					$('#refreshContent').show();
					for(var i=0; i<histories.length; i++){
						var data = histories[i];
						if(sessionStorage.getItem('showEndMsg') && i == histories.length - 1){
							showEndMsg();
							continue;
						}
						data.message = checkUrl(data.message,'history');
						addMessageToChatContent(data);
					}
					$('#refreshContent').hide();
					if(sessionStorage.getItem('isAdvisorClose')){
						$('.chatInput').attr('disabled',true);
						$('#sendMsg').attr('disabled',true);
						socket.close();
					}else if(sessionStorage.getItem('isWaiting')){
						$('.chatInput').attr('disabled',true);
						$('#sendMsg').attr('disabled',true);
					}
				});
				socket.on('typing', function(){
					$('.typeTip').show();
				});
				socket.on('stopTyping', function(){
					hideTypeTip();
				});
				$('.chatInput').keydown(function(e) {  
				    if (e.keyCode === 13){
			            var msg = $(this).val();
			            if (!msg) {
			            	return;
			            }
			            //confirm send typing event in next input
			            typing = false;
			            socket.emit('user_message',{message:msg,chat_session_id:chat_session_id});
			            $(this).val('');
			        }
			   });
				$("#closeChat").click(function(){
					if(reconnectTime){
						clearTimeout(reconnectTime);
						reconnectTime = null;
					}
					socket.emit('user_close');
					socket.close();
					chat_session_id = null;
					sessionStorage.removeItem('isAdvisorClose');
					sessionStorage.removeItem('system_data');
					sessionStorage.removeItem('topic_content_data');
					sessionStorage.removeItem('chatSessionId');
					sessionStorage.removeItem('isWaiting');
					sessionStorage.removeItem('showEndMsg');
					closeChat();
				});
				$('.chatInput').on('input', function(){
					if(socket.disconnected && !socket.connected){
						return;
					}
			    	updateTyping();
			    });
				function updateTyping(){
					if(!typing){
						typing = true;
						socket.emit('typing');
					}
					lastTypingTime = new Date().getTime();
					setTimeout(function(){
	    	    		 var timeInterval = new Date().getTime() - lastTypingTime;
	    	    		 if(timeInterval >= typingTimeLength && typing){
	    	    			 socket.emit('stopTyping');
	    	    			 typing = false;
	    	    		 }
	    	    	}, typingTimeLength);
				}
				$("#sendMsg").click(function(){
					sendMessage();			
				});
				function sendMessage(){
					var msg = $('.chatInput').val();
					if (!msg) {
		                return;
		            }			
					socket.emit('user_message',{message:msg,chat_session_id:chat_session_id});
				    $('.chatInput').val('');
				}
				
				socket.on('disconnect', function(){
					//The client should not see the type...
					$('.chatInput').attr('disabled',true);
					$('#sendMsg').attr('disabled',true);
					hideTypeTip();
				});
				
				socket.on('reconnecting', function(attempt){
					console.log('reconnecting'+attempt);
					if(attempt == 1){
						flag = false;
						reconnectTime = setTimeout(changeFlag, chatReconnectTimeout);
					}
					if(attempt >= 3){
						$('.status_bar').text('You are reconnecting...');
						setTimeout(clearMsg,10000);
					}
				});
				
				socket.on('reconnect', function(attempt){
					if(reconnectTime){
						clearTimeout(reconnectTime);
						reconnectTime = null;
					}
					$('.chatInput').attr('disabled',false);
					chatObj.sessionId = chat_session_id;
					var queue_id = sessionStorage.getItem('queueId');
					chatObj.queue_id = queue_id;
					console.log("reconnect chat..."+attempt);
					if(!flag){
						socket.emit('reconnectChatter', chatObj, function(existSession){
							if(!existSession){
								changeFlag();
							}
						});
						if(attempt >= 3){
							$('.status_bar').text('Your connection has been restored.');
							setTimeout(clearMsg,10000);
						}
					}
				});
				
				function addMessageToChatContent(data){
					if(data.author == 'User'){
						$('.chatContent').append('<div class="send-msg clearfix"><div class="clearfix"><div class="right"><div class="msg-box"><p>'+
								data.message+'</p></div><div class="time timeleft small text-muted">'+convertTo12Time(data.time)+'</div></div></div></div>');
					}else {
						$('.chatContent').append('<div class="reply-msg clearfix"><div class="clearfix"><div class="left"><div class="msg-box"><p class="space">'+
								data.message+'</p></div><div class="time timeright small text-muted">'+convertTo12Time(data.time)+'</div></div></div></div>');
					}
					var content = $('.chatContent');
			    	content.scrollTop(content.prop('scrollHeight'));
			    	hideTypeTip();
				}
				
				function hideTypeTip(){
					$('.typeTip').hide();
				}
				
				function clearMsg(){
					$('.status_bar').text('');
				}
				function changeFlag(){
					flag = true;
					showEndMsg();
				}
				function showEndMsg(){
					var data = {
							message:'Chat session has been closed. Update Case successful. Case Number is',
							time: new Date().getTime(),
							author: 'System'
						};
						addMessageToChatContent(data);
						sessionStorage.setItem('showEndMsg',true);
						socket.close();
				}
			})
		}
		
		function jsonp(url, data, callback) {
		    var xhr = $.getJSON(url + '?jsoncallback=?', data, callback);

		    // request failed
		    xhr.fail(function(jqXHR, textStatus, ex) {
		    	alert('There is a server connectivity issue. Please try again.');
		    });

		    // ie 8+, chrome and some other browsers
		    var head = document.head || $('head')[0] || document.documentElement; // code from jquery
		    var script = $(head).find('script')[0];
		    script.onerror = function(evt) {
		    	alert('There is a server connectivity issue. Please try again.');
		        if (script.parentNode) {
		            script.parentNode.removeChild(script);
		        }
		        // delete jsonCallback global function
		        var src = script.src || '';
		        var idx = src.indexOf('jsoncallback=');
		        if (idx != -1) {
		            var idx2 = src.indexOf('&');
		            if (idx2 == -1) {
		                idx2 = src.length;
		            }
		            var jsonCallback = src.substring(idx + 13, idx2);
		            delete window[jsonCallback];
		        }
		    };
		}
		
		function closeChat() {
			/*
			 *  close chat
			 */
			isOpen = false;
			$("body").css("position","");
			$('#smartchatWindow').css("visibility", "hidden");
			$('body').css("overflow-y", "auto");
			$(".chatInput").val('');
			$(".chatContent").empty();
			$(".chatInput").unbind('keydown');
			$("#sendMsg").unbind('click');
			removeCookie("isOpened");
		}
		
		function fillZero(v){
	        if(v<10){v='0'+v;}
	        return v;
	    }
		
		function convertTo12Time(date,type){
		    var H,I;
	        var d=new Date(date);
	        H=fillZero(d.getHours());
	        I=fillZero(d.getMinutes());
	        var time = H+':'+I;
	        if(H>0 && H<12){
            	time=time+' AM';
            }else if(H==12){
            	time=time+' PM';
            }
	        else if(H>12 && H<24){
                H-=12;
                H=fillZero(H);
                time=H+':'+I+' PM';
            }else if(H==0o0){
                H='12';
                time=H+':'+I+' AM';
            }
	        return time;
		}
		var mobileBrowser = function(){
			var u = navigator.userAgent;
			return !!u.match(/AppleWebKit.*Mobile.*/);
		}
		var iPhoneBrowser = function(){
			var u = navigator.userAgent;
			return (u.indexOf("iPhone") > -1) || (u.indexOf("iPad") > -1);
		}
		function changeMobileChatcontentHeigh(){
			if (mobileBrowser() && !iPhoneBrowser()){
				$('#smartchatWindow').css('height','100%');
				$('#smartchatWindow').css('width','100%');
				$('#smartchatWindow').css('right','0px');
			}
			if (iPhoneBrowser()){
				$('#smartchatWindow').css('height',($(window).innerHeight()));
				$('#smartchatWindow').css('width',($(window).innerWidth()));
				$('#smartchatWindow').css('right','0px');
			}
		}
		//add cookie to recognize whether or not chat window already opened.
		function setCookie(name,value,exdays){
			var d = new Date();  
			d.setTime(d.getTime() + (exdays*24*60*60*1000));  
			var expires = "expires="+d.toUTCString();  
			document.cookie = name + "=" + value + "; " + expires + "; path=/";
		}
		
		function getCookie(name)
		{
			var name = name + "=";
			var ca = document.cookie.split(';');
			  for(var i=0; i<ca.length; i++) 
			  {
			    var c = ca[i].trim();
			    if (c.indexOf(name)==0) return c.substring(name.length,c.length);
			  }
			return "";
		}
		
		function checkCookie()
		{
			console.log("Chat connect")
			var name = getCookie("isOpened");
			if(name != null && "" != name){
				console.log("Chat connect if")
				alert('You already have a chat session opened. Please resume that chat, or close it and start another.');
				return true;
			}else{
				console.log("Chat connect else")
				return false;
			}
		}
		
		function removeCookie(name)
		{ 
			setCookie(name, '',-1); 
		}
		
		$(window).on("beforeunload", function(event){
			if(isOpen === true){
				sessionStorage.setItem('refreshPage',true);
				sessionStorage.setItem('isOpen',true);
				sessionStorage.setItem('chatSessionId',chat_session_id);
				removeCookie("isOpened");
			}
		});
		
		function checkUrl(str,event) {
			var msg;
			  var matchTheDashAndContent = /\<|\>|"|'/g;
			  var matchLink = /(https?:[^\s\<\)\>\<\]\>]+|www.[^\s\<\)\>\<\]\>]+)/gim;
			  var regularMatchingLink = /(https?:[^\s]+)/gim;
			  var matchLabelAContent = /\[[^\[]*\]\([^\)]*\)/g;
			  var matchLabelATitle = /\[[^\[]*\]/;
			  var matchLabelALink = /\([^\)]*\)/;
			  var matchLabelA = /<a([\s]+|[\s]+[^<>]+[\s]+)href=(\"([^<>"\']*)\"|\'([^<>"\']*)\')[^<>]*>/;
			  if( str.match( matchTheDashAndContent ) ){
				  var matchText  = str.match( matchTheDashAndContent );
				  for( var i in matchText ){
					  if( typeof( matchText[i])=='string' ){
						  str = str.replace( matchText[i], $('<span/>').text( matchText[i] ).html());
					  }
				  }
			  }
			  if( str.match( matchLink ) ){
				  str = str.replace( matchLink, '<a href="$1" target="_blank">$1</a> ');
			  }
			  if( str.match( matchLabelAContent ) ){ 
				  var matchText = str.match( matchLabelAContent );
				  for( var i in matchText ){
					  if( typeof( matchText[i])=='string' && matchText[i].match( matchLabelATitle ) && matchText[i].match( matchLabelALink ) ){
						  var temptitle = matchText[i].match( matchLabelATitle )[0];
						  var title = temptitle.substring(1,temptitle.length-1);
						  var as = '';
						  if( title.match( matchLabelA ) ){
							  as = $('<div>').append(title).find('a');
							  title = as[0].innerHTML; 
						  }
						  var templink = matchText[i].match( matchLabelALink )[0];
						  var link = templink.substring(1,templink.length-1);
						  if( link.match( matchLabelA )){
							  as = $('<div>').append(link).find('a');
							  link = as[0].innerHTML;
						  }
						  str = str.replace(matchText[i], '<a target="_blank" href="'+link+'">'+title+'</a>');
					  }
				  }
			  }
			  if((event==='advisor_message')||(event==='user_message')||(event==='topicContent')){
				msg=str;
			  return msg;
			  }
			  else{
				msg =decodeURIComponent(escapeHTML(str));
				return msg;
			  }
		}
		
		function msgSound() {
			if (window.ActiveXObject || "ActiveXObject" in window){
	    		var bg_sound = document.getElementById('bg_sound');
				bg_sound.src = chatServerUrl+'/chat/voice/userMsg.wav'; 
	    	}else{
				var audio = new Audio();
				audio.setAttribute("src", chatServerUrl+'/chat/voice/userMsg.wav');
				audio.play();
	    	}
		}
		
		return this;
	}

})(jQuery);
jQuery(document).ready(function(){
	jQuery('.chatInput').on('focus', function(e) {
		e.preventDefault(); e.stopPropagation();
		window.scrollTo(0,0); //the second 0 marks the Y scroll pos. Setting this to i.e. 100 will push the screen up by 100px.
	});
});